var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"src":_vm.tickSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }